'use strict';
const angular = require('angular');

module.exports = angular.module('spinnaker.core.pipeline.stage.executionWindows.transformer', [])
  .service('executionWindowsTransformer', function() {

    //Overrides "running" status, setting it to "suspended"
    function transformRunningExecutionWindows(execution) {
      var hasRunningStage = false,
          inRestrictedWindow = false;
      execution.stages
        .filter(function (stage) {
          return stage.type === 'restrictExecutionDuringTimeWindow' && stage.status === 'RUNNING';
        })
        .forEach(function (stage) {
          inRestrictedWindow = true;
          stage.status = 'SUSPENDED';
          stage.tasks.forEach(function(task) { task.status = 'SUSPENDED'; });
        });

      if (inRestrictedWindow && execution.status === 'RUNNING') {
        hasRunningStage = execution.stages.some(function (stage) {
          return stage.status === 'RUNNING';
        });
        if (!hasRunningStage) {
          execution.status = 'SUSPENDED';
        }
      }
    }
    this.transform = function(application, execution) {
      transformRunningExecutionWindows(execution);
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/stages/executionWindows/executionWindows.transformer.js